import { type ReactNode } from 'react'
import { Select } from '@base-ui/react/select'
import { twMerge } from 'tailwind-merge'
import { listPopup } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface SelectPopupProps extends PartProps<Select.Popup.Props> {
  className?: string
  children: ReactNode
}

/**
 * The list is at least the trigger's width, and grows to fit a longer option up to 320px (or the
 * room the window has) before that option truncates. It floats on the overlay surface. Its shadow is its edge, so it
 * takes no border. It grows out of the trigger and shrinks back into it, as every list does (see
 * `listPopup`).
 */
function SelectPopup({ className, children, ...props }: SelectPopupProps) {
  return (
    <Select.Popup
      className={twMerge(
        listPopup,
        // At least the trigger's width, and up to 320px for a longer option before it truncates.
        '-webkit-app-region-no-drag z-[100] min-w-[var(--anchor-width)] max-w-[min(max(var(--anchor-width),320px),var(--available-width))]',
        className,
      )}
      {...props}
    >
      {children}
    </Select.Popup>
  )
}

export { SelectPopup }
